export function sortLine(obj) {
  const line = {}
  const sortArray =  (array) => {
    return array[1]
  }

  for (let key in obj) {
    let sortLine =  obj[key].map(sortArray)
    line[key] = sortLine
  }

  return line
}
